<template>
  <div>
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="销货退货单打印"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="api.list"
      show-summary
      :summary-method="getSummaries"
      @check-change="checkChange"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right">
          <el-button size="mini" type="primary" @click="print('qualityPrintbatchReturn')" :disabled='!btntype'>销货退货单批量打印</el-button>
          <el-button size="mini" type="primary" @click="printAll('qualityPrintbatchQueryReturn')" >销货退货单筛选打印</el-button>
        </slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <customer @restaurants="setSupplier" :state="params.CustomerName" />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input clearable v-model="params.OrderNo" placeholder="请输入订单编号" />
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库状态">
          <el-select v-model="params.OutStatus" placeholder="请选择" clearable>
            <el-option label="未出库" :value="0"></el-option>
            <el-option label="部分出库" :value="1"></el-option>
            <el-option label="已出库" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票状态">
          <el-select v-model="params.InvoiceStatus" placeholder="请选择" clearable>
            <el-option label="未完成" :value="1"></el-option>
            <el-option label="已完成" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款状态">
          <el-select v-model="params.ReceiptStatus" placeholder="请选择" clearable>
            <el-option label="未收款" :value="0"></el-option>
            <el-option label="部分收款" :value="1"></el-option>
            <el-option label="已收款" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" min-width="110px" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">{{row.DocDate.split(" ")[0]}}</template>
        </el-table-column>
        <el-table-column prop="CustomerName" label="客户名称" min-width="110px" />
        <el-table-column prop="Amount" label="退货金额">
          <template slot-scope="{row}">{{$commonJs.toThousands(row.Amount)}}</template>
        </el-table-column>
        <el-table-column prop="OrderNo" label="订单编号" min-width="110px" />
        <el-table-column prop="ClerkName" label="业务员" />
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-else-if="row.Status==1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="OutStatus" label="退库状态">
          <template slot-scope="{row}">
            <span v-if="row.OutStatus==0">未退库</span>
            <span v-else-if="row.Status==1">部分退库</span>
            <span v-else>已退库</span>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptStatus" label="退款状态">
          <template slot-scope="{row}">
            <span v-if="row.ReceiptStatus==0">未退款</span>
            <span v-else-if="row.ReceiptStatus==1">部分退款</span>
            <span v-else>已退款</span>
          </template>
        </el-table-column>
        <el-table-column prop="InvoiceStatus" label="开票状态">
          <template slot-scope="{row}">
            <span v-if="row.InvoiceStatus==0">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    
    <tradeunit-dialog ref="tradeunitDialog" selectable @select="setTradeunit" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <class-dialog
      ref="classDialog"
      selectable
      multiple
      @select="setClass"
      title="商品分类"
    />
    <warehouse-dialog
      ref="warehouseDialog"
      in-dialog
      selectable
      @select="setWarehouse"
      title="仓库列表"
      :typeList="[1, 2]"
    />
    <unit-dialog
      ref="unitDialog"
      in-dialog
      selectable
      @select="setUnit"
      title="客户列表"
      :typeList="[1,2]"
    />
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import empDialog from "@/components/sales/business/empDialog";
import tradeunitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import classDialog from "@/components/basicinfo/goods/archives/goodsTree/listDialog";
import warehouseDialog from "@/components/basicinfo/basic/warehouse/listDialog";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";
export default {
  mixins: [listMixin],
  components: {
    list,
    tradeunitDialog,
    empDialog,
    classDialog,
    warehouseDialog,
    unitDialog,
    customer
  },
  data() {
    return {
      api: require("@/api/sale/saBackDoc").default,
      params: {
        GoodsName: "",
        DocNo: "",
        DocDateStart: this.$dayjs()
        .format("YYYY-MM-DD"),
        DocDateEnd: this.$dayjs()
        .format("YYYY-MM-DD"),
        IdChain: "",
        ClassName: "",
        ClerkId: "",
        ClerkName: "",
        CustomerId: "",
        CustomerName: "",
        WarehouseName: "",
        WarehouseId:"",
        IsRepair:"",
        Status:2,
      },
      isMB: this.$store.state.isMB,
      btntype:false
    };
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs()
        .endOf("month")
        .format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
    checkChange(e){
         if(e.length>0){
           this.btntype=true
         }else{
           this.btntype=false
         }
    },
    print(url) {
      let rows = this.$refs.list.getCheckedRows();
       
      let newpage = this.$router.resolve({ 
        path: '/'+url+'?sid='+ rows.map(v=>v.DocId).join(',')
      })
      window.open(newpage.href, '_blank');
    },
    printAll(url) {
      //let rows = this.$refs.list.getCheckedRows();
       
      let newpage = this.$router.resolve({ 
        path: '/'+url,
        params: this.params,
        query:this.params
      })
      window.open(newpage.href, '_blank');
    },
    
    setSupplier(data) {
      
      this.params.CustomerId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
      this.params.CustomerType = data.TradeUnitType;
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      
      this.params.CustomerId = e.TradeUnitId;
      this.params.CustomerName = e.TradeUnitName;
    },
    // checkChange(e){
    //     this.$emit("check-change", e);
    // },
    setWarehouse(e) {
      
      this.params.WarehouseId = e.WarehouseId;
      this.params.WarehouseName = e.WarehouseName;
      // this.data.CustomerType = e.TradeUnitType
    },
    addwarehouse(e) {
      this.$refs.warehouseDialog.open().then((that) => {
        that.getData({});
        that.getTree();
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    getSummaries(param) {
      
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if ( index === 4) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor((prev + curr) * 100) / 100;
              } else {
                return Math.floor(prev * 100) / 100;
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId;
      this.data.ClerkName = e.EmpName;
    },
    setClass(data) {
      
      this.params.IdChain = data.IdChain;
      this.params.ClassName = data.ClassName;
    },
    openClass() {
      this.$refs.classDialog.open().then((that) => {
        that.getData({ Status: 1, ClassType: 6 });
      });
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    addEmp() {
      // let ids = this.PriAdjustEmpList.map((x) => x.EmpId);
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setTradeunit(data) {
      this.params.CustomerId = data.Id;
      this.params.CustomerName = data.Name;
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    onClick(row) {
      
      this.$refs.listDialog.open().then((that) => {
        var params = {
          TradeUnitId: row.TradeUnitId,
          TradeUnitName: row.TradeUnitName,
          DocDateStart: this.params.DocDateStart,
          DocDateEnd: this.params.DocDateEnd,
        };
        that.query(params);
      });
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs()
            .subtract(1, "day")
            .format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs()
            .subtract(2, "day")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs()
            .subtract(6, "day")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs()
            .subtract(13, "day")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs()
            .startOf("week")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs()
            .startOf("quarter")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs()
            .startOf("year")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
  },
};
</script>
